export default __webpack_public_path__ + "locales/pt/People.json?hash=b02d1dc54a9399b92618d294ff3e4b09";